import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Typography } from '@mui/material';
import { DataGrid } from '@unicorn-shared/interface';
import { ConfirmDialog } from '@shared/ui';
import {
  allreadyRelatedColumns,
  $allreadyRelatedTickets,
  clearAllreadyRelatedTickets,
  forceRelatedSave,
} from '../../../models/related-tickets';
import * as Styled from '../styled';

export const AllreadyRelatedTickets = () => {
  const { t } = useTranslation();
  const [tableData] = useUnit([$allreadyRelatedTickets]);

  return (
    <ConfirmDialog
      title={t('ConfirmingTheAdditionOfConnection')}
      content={
        <Styled.DialogText>
          <Typography variant="body1">
            {t('SomeApplicationsAlreadyLinkedToAnotherIncidentAlert')}
          </Typography>

          <div>
            <DataGrid
              name="allready-related-tickets"
              columns={allreadyRelatedColumns}
              rows={tableData}
              showPagination={false}
              showAllRows
            />
          </div>
        </Styled.DialogText>
      }
      isOpen={!!tableData.length}
      onClose={() => clearAllreadyRelatedTickets()}
      onConfirm={() => {
        clearAllreadyRelatedTickets();
        forceRelatedSave();
      }}
    />
  );
};
